import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';

import Button from '~/shared/components/ButtonsV2';
import Typography from '~/shared/components/Typography';
import DeleteIcon from '~/shared/assets/icons/delete.svg';

interface RemoveRoleArnModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRemove: () => void;
  isLoading?: boolean;
  accountName?: string;
}

export function RemoveRoleArnModal({
  isOpen,
  onClose,
  onRemove,
  isLoading = false,
  accountName,
}: RemoveRoleArnModalProps) {
  return (
    <Dialog open={isOpen} as="div" className="relative z-[99] focus:outline-none" onClose={onClose}>
      <div className="fixed inset-0 w-screen overflow-y-auto bg-[#00000059] backdrop-blur-[6px]">
        <div className="flex min-h-screen items-center justify-center">
          <DialogPanel
            transition
            className="flex my-auto w-full max-w-[689px] flex-col rounded-xl bg-white backdrop-blur-2xl duration-300 ease-out overflow-hidden data-closed:transform-[scale(95%)] data-closed:opacity-0 "
          >
            <div className="flex flex-col w-full items-center">
              <div className="flex flex-col w-full items-center px-12 pt-9 pb-6">
                <div className="w-8 mb-[24px]">
                  <DeleteIcon className="size-6 text-red" />
                </div>
                <DialogTitle
                  as="h3"
                  className="text-2xl 2xl:text-[24px] font-[500] mb-[10px] text-center font-family-outfit leading-6"
                >
                  Are you sure you want to remove the IAM role from {accountName || 'this account'}?
                </DialogTitle>
                <Typography variant="p3" className="max-w-[593px] text-center font-family-inter">
                  Datafy will no longer have permissions in {accountName || 'this account'}, and
                  installed agents will not operate as expected
                </Typography>
              </div>

              <div className="flex items-center justify-center gap-3 w-full py-6">
                <Button
                  variant="primary"
                  className="w-[152px] h-[44px]"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  <Typography variant="p3" color="text-white">
                    No, cancel
                  </Typography>
                </Button>
                <Button
                  variant="third"
                  className="w-[152px] h-[44px]"
                  onClick={onRemove}
                  loading={isLoading}
                  disabled={isLoading}
                >
                  <Typography variant="p3" color="text-primary-900">
                    Yes, remove
                  </Typography>
                </Button>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
